export default class Locker {
    constructor($objectUri) {
        this.lockEnabled = true;
        this.objectUri = $objectUri;
        if (this.objectUri.length == 0)
            this.lockEnabled = false;
        if (!this.objectUri.startsWith("/"))
            this.objectUri = "/" + this.objectUri;
        this._uri = "/api/auth/lock" + this.objectUri;
        this.status = "request"; // acquired, denied, removed, loosed
        this._th = -1;
    }
    // dispone seolo l'attivita
    dispose(hard = true) {
        clearTimeout(this._th);
        this._th = -1;
        //this._polling = false;
    }
    // ACUIRE
    acquire(callBack) {
        this.dispose(false);
        //
        if (this.lockEnabled) {
            thatServiceManager.standardCall(this._uri, null, this._acquire_handler.bind(this, callBack), "PUT");
        } else {
            this.status = "acquired";
            if (callBack) {
                try {
                    callBack(this.status, null , null); 
                } catch (ex) {

                }
            }
        }

    }
    _acquire_handler(callBack, rs) {
        if (rs && rs.Success) {
            this.status = "acquired";
        } else {
            this.status = "denied";
        }
        if (callBack) {
            try {
                callBack(this.status, rs ? rs.LockStatus : { acquired: false }, rs ? rs.RecordStatus : null);
            } catch (ex) {

            }
        }
    }
    // RENEW THREAD
    startRenewThread(callBack, $tmo = 30000) {
        if (this.lockEnabled) {
            this.dispose(false);
            //
            this._th = setTimeout(this._polla.bind(this, callBack, $tmo), $tmo);
        }
    }
    _polla(callBack, $tmo) {
        thatServiceManager.standardCall(this._uri, null, this._polla_handler.bind(this, callBack, $tmo), "GET");
    }
    _polla_handler(callBack, $tmo, rs) {
        if (rs && rs.Success) {
            this.status = "acquired";
        } else {
            this.status = "loosed";
        }
        if (callBack && this.status == "loosed") {
            this.dispose(false);
            try {
                callBack(this.status, rs ? rs.LockStatus : { acquired: false });
            } catch (ex) {
            }
        }
        if (this.status == "acquired" && this._th != -1) {
            this._th = setTimeout(this._polla.bind(this, callBack, $tmo), $tmo);
        }
    }
    // RENEW
    renew(callBack) {
        if (this.lockEnabled) {
            this.dispose(false);
            //
            thatServiceManager.standardCall(this._uri, null, this._renew_handler.bind(this, callBack), "GET");
        }
    }
    _renew_handler(callBack, rs) {
        if (rs && rs.Success) {
            this.status = "acquired";
        } else {
            this.status = "denied";
        }
        if (callBack) {
            try {
                callBack(this.status, rs ? rs.LockStatus : { acquired: false });
            } catch (ex) {

            }
        }
    }
    // RELEASE
    release(strong, callBack, timeWait = 0) {
        this.dispose(false);
        //
        thatServiceManager.standardCall(this._uri + "?strong=" + strong, null, this._release_handler.bind(this, callBack), "DELETE");
        //
        if (timeWait > 0) {
            let n = (new Date()).getTime();
            while ((new Date()).getTime() - n < timeWait) {
                console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
            }
        }
    }
    _release_handler(callBack, rs) {
        if (rs && rs.Success) {
            this.status = "removed";
        } else {
            this.status = "denied";
        }
        if (callBack) {
            try {
                callBack(this.status, rs ? rs.LockStatus : { acquired: false });
            } catch (ex) {

            }
        }
    }

}